export default __webpack_public_path__ + "static/media/store.3338bc42.svg";